export default __webpack_public_path__ + "static/media/harsh.75f023fa.jpeg";